import { ChevronRight } from '@mui/icons-material';
import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';

interface BreadcrumbProps {
  /** Texto del nivel raíz, clicable. */
  parentLabel: string;
  /** Texto del nivel actual (no clicable). */
  currentLabel: string;
  onParentClick?: () => void;
}

const Trail = styled.nav({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 14,
  fontFamily: t.font,
  fontSize: 13.5,
  color: t.color.muted,
  '& .MuiSvgIcon-root': { fontSize: 17 },
});

const Parent = styled.button({
  border: 'none',
  background: 'transparent',
  padding: 0,
  cursor: 'pointer',
  fontFamily: t.font,
  fontSize: 13.5,
  fontWeight: 500,
  color: t.color.primary,
  '&:hover': { textDecoration: 'underline' },
});

const Current = styled.span({ color: t.color.text });

/**
 * Molécula de migas de pan de dos niveles: raíz clicable + nivel actual.
 */
const Breadcrumb = ({ parentLabel, currentLabel, onParentClick }: BreadcrumbProps) => (
  <Trail>
    <Parent type="button" onClick={onParentClick}>
      {parentLabel}
    </Parent>
    <ChevronRight />
    <Current>{currentLabel}</Current>
  </Trail>
);

export default Breadcrumb;
